module.exports = __webpack_public_path__ + "0bd8c1368361ff356b47d8dd0933e871.png";